import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import React from "react";
import { withTransientProps } from "core/utils/transientProps";

/**
 * A panel which is scrollable when it overflows.
 * Needs to be within a fixed container otherwise it will grow and the scrollbar won't show.
 */
export const ScrollablePanel = ({ header, children, footer }) => {
  const ScrollableContentWrapper = footer
    ? MiddleScrollableContent
    : BottomScrollableContent;

  return (
    <>
      <Header>{header}</Header>
      <ScrollableContentWrapper $hasFooter={!!footer}>
        {children}
      </ScrollableContentWrapper>
      {footer && <Footer>{footer}</Footer>}
    </>
  );
};

ScrollablePanel.propTypes = {
  /** A header section which doesn't scroll*/
  header: PropTypes.node.isRequired,
  /** The children*/
  children: PropTypes.node.isRequired,
  /** An optional footer section which doesn't scroll*/
  footer: PropTypes.node
};

const Header = styled("div")`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing(3)} ${props => props.theme.spacing(3)}
    0 ${props => props.theme.spacing(3)};
`;

const Footer = styled("div")`
  display: flex;
  flex-direction: column;
  padding: 0 ${props => props.theme.spacing(3)}
    ${props => props.theme.spacing(3)} ${props => props.theme.spacing(3)};
`;

const ScrollableContent = styled("div", withTransientProps)`
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex-grow: 1;
  padding: ${props =>
    props.$hasFooter
      ? `0 ${props => props.theme.spacing(3)} 0 ${props =>
          props.theme.spacing(3)}`
      : `0 ${props => props.theme.spacing(3)}
    ${props => props.theme.spacing(3)} ${props => props.theme.spacing(3)};`};
`;

const MiddleScrollableContent = styled(ScrollableContent)`
  padding: 0 ${props => props.theme.spacing(3)} 0
    ${props => props.theme.spacing(3)};
`;

const BottomScrollableContent = styled(ScrollableContent)`
  padding: 0 ${props => props.theme.spacing(3)}
    ${props => props.theme.spacing(3)} ${props => props.theme.spacing(3)};
`;
